import React, {ReactNode} from 'react'
import EventEmitterEx from '../pageBaseComponents/EventEmitterEx'

interface ExternalProps {
    eventEmitter: EventEmitterEx
}

export const withScroller = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;

    return class extends React.PureComponent<ResultProps> {
        static displayName: string = `withScroller(${WrappedComponent.displayName})`
        myRef: HTMLDivElement | null

        constructor(props: Readonly<ResultProps>) {
            super(props)
            this.handleScrollTo = this.handleScrollTo.bind(this)
            this.handleScrollToTop = this.handleScrollToTop.bind(this)
            this.myRef = null
        }

        handleScrollTo(): void {
            if (!this.myRef) {
                return
            }
            window.scrollTo(0, this.myRef.offsetTop)
        }

        handleScrollToTop(): void {
            window.scrollTo(0, 0)
        }

        componentDidMount(): void {
            this.props.eventEmitter.on('scrollToContentsTop', this.handleScrollTo)
            this.props.eventEmitter.on('scrollToTop', this.handleScrollToTop)
        }

        componentWillUnmount(): void {
            this.props.eventEmitter.off('scrollToContentsTop', this.handleScrollTo)
            this.props.eventEmitter.off('scrollToTop', this.handleScrollToTop)
        }

        render(): ReactNode {
            return (
                <div ref={(ref) => this.myRef = ref}>
                    <WrappedComponent {...this.props} />
                </div>
            )
        }
    }
}
